import type { CSSObject } from 'styled-components';
import React from 'react';

import { DropdownContainer, DropdownElement } from './DropdownPopup.styles';
import { DropdownElementProps, DropdownProps } from './DropdownPopup.types';

export const DropdownPopup = ({ items, placement, floatingStyles, innerRef, onClick }: DropdownProps) => {
  const floatingCss: CSSObject = {
    bottom: floatingStyles.bottom,
    left: floatingStyles.left,
    position: floatingStyles.position,
    right: floatingStyles.right,
    top: floatingStyles.top,
    transform: floatingStyles.transform,
    willChange: floatingStyles.willChange,
  };
  const handleClick = (item: DropdownElementProps) => () => onClick(item);

  return (
    <DropdownContainer
      className="dropdown__container"
      ref={innerRef}
      $floatingStyles={floatingCss}
      data-placement={placement}
    >
      {items.map((item: DropdownElementProps) => (
        <DropdownElement key={item.key} onClick={handleClick(item)} className="dropdown__element">
          {item.label}
        </DropdownElement>
      ))}
    </DropdownContainer>
  );
};
